import { strategies_obj } from "../../utils/Constant"

const Strategies = () => {
    return (
        <>
            <div className="technologies_main_div">
                <h2 className="technologies_h2">
                    Strategies & Communication
                </h2>
                <p className="technologies_p">
                    Communication and collaboration is the mother of productivity. Intelivita’s productivity
                    is dependent on these tools that help us strategize, communicate and collaborate seamlessly.
                </p>
                <div className="technologies_card_main_div">
                    {strategies_obj?.map((v, i) => {
                        return (
                            <>
                                <div className="technologies_card_inner_div">
                                    <img src={v?.img} />
                                </div>
                            </>
                        )
                    })
                    }
                </div>
            </div>
        </>
    )
}
export default Strategies